import React from 'react'
import url from 'libraries/front-end-core/core/url'
import { CURRENT_AWARENESS } from 'constants/controllers'
import CAQuickDatePickers from 'components/search/CAQuickDatePickers'
import SearchFiltersContainer from 'redux/containers/pages/currentawareness/SearchFiltersContainer'
import dayjs from 'dayjs'
import { pushEvent } from 'services/AnalyticsService'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import CalenderDatePickers from 'components/shared/calender-date-pickers'
import useDatePicker from 'hooks/useDatePicker'

dayjs.locale('en')

const Filters = (props) => !props.searchPhrase
  ? <BrowseFilters {...props} />
  : <SearchFiltersContainer {...props} />

const submitDates = (fromDate, toDate, aol) => {
  const getUrl = () => url(CURRENT_AWARENESS, { aol, fromDate, toDate })
  pushEvent({ category: 'Current Awareness', action: 'Filter', label: `Date range from ${fromDate} to ${toDate}` })
  replaceUrl(getUrl())
}

const BrowseFilters = ({ fromDate, toDate, aol }) => {
  const datePicker = useDatePicker(fromDate, toDate)
  const onHandleButtonSubmit = () => submitDates(datePicker.fromDateSelected, datePicker.toDateSelected, aol)

  return (
    <div className='ph6 ph4-t pb10'>
      <div data-help-item='caquicklinks' data-help-position='middle'>
        <CAQuickDatePickers
          fromDate={fromDate}
          toDate={toDate}
          getUrl={compare => url(CURRENT_AWARENESS, { aol: aol || 'corporate', ...compare })}
          aol={aol || 'corporate'}
        />
      </div>
      <CalenderDatePickers {...{ ...datePicker, onHandleButtonSubmit, theme: 'ca' }} />
    </div>
  )
}

export default Filters
